import React from 'react'
import BoutonRetourHome from './sub-components/BoutonRetourHome';
import TagManager from 'react-gtm-module';

// Les cas 3 et 21 (succès) sont gérés par redirection vers /merci
// Ce composant gère uniquement les états transitoires et l'erreur critique
const Confirmation = ({ etapeInscription }) => {

    switch (etapeInscription) {
        case 1:
            TagManager.dataLayer({ dataLayer: { event: 'eni_ConfirmationLoad' }, dataLayerName: 'PageDataLayer' });
            break;
        case 11:
            TagManager.dataLayer({ dataLayer: { event: 'eni_ConfirmationFail' }, dataLayerName: 'PageDataLayer' });
            break;
        case 2:
            TagManager.dataLayer({ dataLayer: { event: 'eni_ConfirmationSuccessInscription' }, dataLayerName: 'PageDataLayer' });
            break;
        default:
            TagManager.dataLayer({ dataLayer: { event: 'eni_ConfirmationLoad' }, dataLayerName: 'PageDataLayer' });
            break;
    }

    switch (etapeInscription) {
        case 1: return (
            <div>
                Inscription en cours, veuillez ne pas fermer cette page.
            </div>
        );
        case 11: return (
            <div>
                <div className="text-center mt-3 alert alert-danger">
                    Erreur lors de l'inscription, veuillez réessayer plus tard. Nous sommes désolé de ce désagrément...
                    Le problème a été transféré à nos équipes.
                </div>
                <BoutonRetourHome />
            </div>
        );
        case 2: return (
            <div>
                L'inscription a été réalisée avec succès. L'envoi de votre CV a débuté, veuillez ne pas fermer cette page.
            </div>
        );
        default:
            return (
                <div>
                    Inscription en cours, veuillez ne pas fermer cette page.
                </div>
            );
    }
}

export default Confirmation